@if (isMobile()) {
  <ng-container *ngTemplateOutlet="quoteOverviewHeader"></ng-container>
} @else if (isStandalone()) {
  <div class="overview-position">
    <pc-responsive-abstract-card class="overview-structure" [size]="'summary-card'">
      <ng-container *ngTemplateOutlet="quoteOverviewHeader"></ng-container>
      <ng-container *ngTemplateOutlet="quoteOverviewContent"></ng-container>
    </pc-responsive-abstract-card>
  </div>
} @else {
  <pc-responsive-abstract-card class="overview-structure" [size]="'summary-wrapper-card'">
    <ng-container *ngTemplateOutlet="quoteOverviewHeader"></ng-container>
  </pc-responsive-abstract-card>

  <div class="overview-position" [@expandCollapse]="quoteOverviewState()">
    <pc-responsive-abstract-card class="overview-structure" [size]="'summary-card'">
      <ng-container *ngTemplateOutlet="quoteOverviewContent"></ng-container>
    </pc-responsive-abstract-card>
  </div>
}

<ng-template #quoteOverviewHeader>
  <pc-quote-overview-header
    [chevronIcons]="chevronIcons()"
    [isMobile]="isMobile()"
    [isQuoteOverviewOpened]="quoteOverviewService.isQuoteOverviewOpen()"
    [isStandalone]="isStandalone()"
    [totalPrice]="totalPremium()"
    [totalPriceDescription]="quoteOverviewLabels().totalPriceDescription"
    [yourQuote]="quoteOverviewLabels().yourQuote"
    (quoteOverviewStateChange)="onQuoteOverviewStateChange()"
  >
  </pc-quote-overview-header>
</ng-template>

<ng-template #quoteOverviewContent let-isEmailSection let-showBrokerFeeIfBrokerSalesProcess>
  <pc-quote-overview-content
    [brokerFee]="quoteOverviewService.brokerFee()"
    [brokerFeeTexts]="quoteOverviewLabels().brokerFeeTexts"
    [destinationsToggleOptions]="quoteOverviewLabels().destinationsToggleOptions"
    [emailQuoteTexts]="quoteOverviewLabels().emailQuoteTexts"
    [gstRate]="GOODS_AND_SERVICES_TAX_RATE"
    [privacyPolicyLink]="quoteOverviewService.privacyPolicyLink()"
    [quoteCoversData]="quoteCoversData()"
    [quoteTripDetailsData]="quoteTripDetailsData()"
    [selectedDestinationAlt]="quoteOverviewLabels().destinationAltPrefix"
    [showBrokerFeeSection]="
      showBrokerFeeIfBrokerSalesProcess === 'false' ? false : processType() === ProcessTypes.AGENTS
    "
    [showEmailSection]="isEmailSection === 'false' ? false : showEmailSection()"
    [travelersAmountText]="quoteOverviewLabels().travelersAmount"
    [tripDetailsIcons]="tripDetailsIcons()"
    (brokerFeeChange)="setBrokerFee($event || 0)"
  >
  </pc-quote-overview-content>
</ng-template>
